import { create } from 'zustand';
import api from '../services/api';

export interface UsageStats {
  tier: string;
  searches_used: number;
  searches_limit: number;
  searches_remaining: number;
  leads_used: number;
  leads_limit: number;
  leads_remaining: number;
  free_search_used: boolean;
  subscription_status: string;
  credits_reset_at?: string | null;
  is_search_blocked?: boolean;
  max_results_per_search?: number;
  analysis_features?: string[];
}

interface UsageState {
  usage: UsageStats | null;
  loading: boolean;
  error: string | null;
  fetchUsage: () => Promise<void>;
}

export const useUsageStore = create<UsageState>((set) => ({
  usage: null,
  loading: true,
  error: null,

  fetchUsage: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get('/user/usage');
      set({ usage: response.data, loading: false });
    } catch (err: any) {
      set({
        error: err.response?.data?.detail || 'Error fetching usage',
        loading: false,
      });
    }
  },
}));
